import jwt from '../../http/requests/auth/jwt/index.js';
import 'firebase/auth';
import axios from '@/axios';

export default {
  getOrderList(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpOrderList(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  getOrderDetails(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpOrderDetail(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  getOrderDetailsIntent(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpOrderDetailIntent(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  regenerateAttachment(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .regeneratePDF(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  regenerateOrderAttachment(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .regenerateOrderPDF(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  updateOrderTracking(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .updateHttpOrderTracking(data.orderNumber, data.body)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  updateOrderTrackingInfo(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .updateHttpOrderTrackingInfo(data.orderNumber, data.body)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  sendInvoiceToClinicFromAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .sendInvoiceToClinicApi(data.id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  sendTrackingToClinicFromAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .sendTrackingToClinicApi(data.id)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchProductsForOrder(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .fetchHttpProductForOrder(data)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  },
  createOrderByAdmin(_context, data) {
    return new Promise((resolve, reject) => {
      jwt
        .createOrderByAdminHttp(data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  resubmitSage(_context, id) {
    return new Promise((resolve, reject) => {
      axios
        .post('/sage/resubmit/' + id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  resendEmail(_context, data) {
    return new Promise((resolve, reject) => {
      jwt.resendEmail(data).then(res=>{
        resolve(res);
      }).catch(err=>{
        reject(err);
      });
    });
  },
  resendCustomerEmail(_context, orderId) {
    return new Promise((resolve, reject) => {
      jwt.resendCustomerEmail(orderId).then(res=>{
        resolve(res);
      }).catch(err=>{
        reject(err);
      });
    });
  },
  getPaginatedOrderList(_context, data) {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/v1/store/orders/paginate-list', { params: data })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
